import { render, staticRenderFns } from "./pkgRiskSubItem.vue?vue&type=template&id=45ffb1aa&"
import script from "./pkgRiskSubItem.vue?vue&type=script&lang=js&"
export * from "./pkgRiskSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports